import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
});

// Attach Authorization header from localStorage if present (fallback to cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("df_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatMoney(n) {
  const v = Number(n || 0);
  return v.toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export const STATUS_LABEL = {
  pendiente: "Pendiente",
  confirmada: "Confirmada",
  en_atencion: "En atención",
  finalizada: "Finalizada",
  cancelada: "Cancelada",
  no_asistio: "No asistió",
};

// Estilo de badge por estado de cita.
// Tailwind clases listas para usar en una <span>.
export const STATUS_BADGE = {
  pendiente:   "bg-zinc-200 text-zinc-700 dark:bg-zinc-700/40 dark:text-zinc-300",
  confirmada:  "bg-sky-100 text-sky-700 dark:bg-sky-500/20 dark:text-sky-300",
  en_atencion: "bg-violet-100 text-violet-700 dark:bg-violet-500/20 dark:text-violet-300 animate-pulse",
  finalizada:  "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300",
  cancelada:   "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300",
  no_asistio:  "bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300",
};

export const ROLE_LABEL = {
  admin: "Administrador",
  odontologo: "Odontólogo",
  recepcionista: "Recepcionista",
};

export const DOCUMENT_TYPES = [
  { value: "CC", label: "Cédula de ciudadanía" },
  { value: "CE", label: "Cédula de extranjería" },
  { value: "TI", label: "Tarjeta de identidad" },
  { value: "RC", label: "Registro civil" },
  { value: "PA", label: "Pasaporte" },
  { value: "NIT", label: "NIT" },
];

export const EPS_LIST = [
  "Sura", "Sanitas", "Compensar", "Nueva EPS", "Salud Total",
  "Famisanar", "Coomeva", "Aliansalud", "SOS", "Mutual SER",
  "Coosalud", "Asmet Salud", "Capital Salud", "Mallamas",
  "Cajacopi", "Emssanar", "Savia Salud", "Ecoopsos",
  "Pijaos Salud", "Anas Wayuu", "Particular / Sin EPS",
];

export const REGIMEN_OPTS = [
  { value: "", label: "—" },
  { value: "contributivo", label: "Contributivo" },
  { value: "subsidiado", label: "Subsidiado" },
  { value: "particular", label: "Particular" },
  { value: "prepagada", label: "Medicina prepagada" },
];

export const BLOOD_TYPES = ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"];

export const GENDER_OPTS = [
  { value: "", label: "—" },
  { value: "F", label: "Femenino" },
  { value: "M", label: "Masculino" },
  { value: "O", label: "Otro" },
];

export const BRUSHING_OPTS = [
  { value: "", label: "—" },
  { value: "1", label: "1 vez al día" },
  { value: "2", label: "2 veces al día" },
  { value: "3+", label: "3 o más al día" },
  { value: "menos", label: "Menos de 1 al día" },
];

export const PAYMENT_METHODS = [
  { key: "efectivo",     label: "Efectivo",            short: "Efectivo",   bg: "#1B4332", fg: "#ffffff" },
  { key: "nequi",        label: "Transferencia Nequi", short: "Nequi",      bg: "#DA0081", fg: "#ffffff" },
  { key: "bancolombia",  label: "T. Bancolombia",      short: "Bancolombia",bg: "#FDDA24", fg: "#000000" },
  { key: "daviplata",    label: "Transferencia Daviplata", short: "Daviplata", bg: "#E10600", fg: "#ffffff" },
  { key: "tarjeta",      label: "Tarjeta débito/crédito", short: "Tarjeta",  bg: "#1E3A8A", fg: "#ffffff" },
  { key: "addi",         label: "Addi",                short: "Addi",       bg: "#5B21B6", fg: "#ffffff" },
];

export const PAYMENT_LABEL = Object.fromEntries(PAYMENT_METHODS.map((m) => [m.key, m.label]));
